import React from "react";
import * as Path from "routes/Path/index";

export const mainModule = [
  /**************DASHBOARD*********/
  {
    url: Path.statistics,
    model_name: "statistics",
    name: "Statistics",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23.4375 22.0703H23.2031V11.9922C23.2031 11.0938 22.4609 10.3125 21.5234 10.3125H19.4141C18.5156 10.3125 17.7344 11.0547 17.7344 11.9922V22.0703H15.2344V14.2578C15.2344 13.3594 14.4922 12.5781 13.5547 12.5781H11.4453C10.5469 12.5781 9.76562 13.3203 9.76562 14.2578V22.0313H7.22656V16.9141C7.22656 16.0156 6.48437 15.2344 5.54687 15.2344H3.4375C2.53906 15.2344 1.75781 15.9766 1.75781 16.9141V22.0313H1.5625C1.09375 22.0313 0.664062 22.4219 0.664062 22.9297C0.664062 23.4375 1.09375 23.8281 1.5625 23.8281H23.4375C23.9062 23.8281 24.3359 23.4375 24.3359 22.9297C24.3359 22.4219 23.9062 22.0703 23.4375 22.0703ZM3.55469 22.0703V17.0312H5.46875V22.0703H3.55469ZM11.5234 22.0703V14.375H13.4375V22.0703H11.5234ZM19.5312 22.0703V12.1094H21.4453V22.0703H19.5312Z"
          fill="white"
        />
        <path
          d="M4.06245 9.72647C4.14057 9.72647 4.2187 9.72647 4.29682 9.6874L19.5312 5.19522L19.0624 5.85928C18.789 6.28897 18.9453 6.79678 19.3359 7.07022C19.4921 7.14834 19.6484 7.1874 19.8046 7.1874C20.0781 7.1874 20.3906 7.03115 20.5468 6.75771L22.1874 4.14053C22.4609 3.71084 22.3046 3.20303 21.914 2.92959L19.2968 1.28896C18.9062 1.01553 18.3593 1.17178 18.0859 1.5624C17.8124 1.95303 17.9687 2.53896 18.3593 2.8124L19.2968 3.39834L3.82807 8.00772C3.35932 8.16397 3.08589 8.63272 3.24214 9.10147C3.32026 9.49209 3.67182 9.72647 4.06245 9.72647Z"
          fill="white"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: ["statistics"],
  },
  /**************USERS*********/
  {
    url: Path.users,
    model_name: "Users",
    name: "Manage Users",
    sidebar_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
      >
        <g clipPath="url(#clip0_175_315)">
          <path
            d="M10.5 11.375C11.4283 11.375 12.3185 11.0062 12.9749 10.3499C13.6313 9.6935 14 8.80326 14 7.875C14 6.94674 13.6313 6.0565 12.9749 5.40013C12.3185 4.74375 11.4283 4.375 10.5 4.375C9.57174 4.375 8.6815 4.74375 8.02513 5.40013C7.36875 6.0565 7 6.94674 7 7.875C7 8.80326 7.36875 9.6935 8.02513 10.3499C8.6815 11.0062 9.57174 11.375 10.5 11.375ZM10.5 11.375C9.10761 11.375 7.77226 11.9281 6.78769 12.9127C5.80312 13.8973 5.25 15.2326 5.25 16.625V19.25M10.5 11.375C11.8924 11.375 13.2277 11.9281 14.2123 12.9127C15.1969 13.8973 15.75 15.2326 15.75 16.625V19.25M11.375 4.375C11.7285 2.919 13.1381 1.75 14.875 1.75C16.7755 1.75 18.3575 3.31625 18.375 5.25C18.3575 7.18375 16.7755 8.75 14.875 8.75M14.875 8.75H14M14.875 8.75C17.752 8.75 20.125 11.1002 20.125 14V15.75M9.625 4.375C9.2715 2.919 7.86188 1.75 6.125 1.75C4.2245 1.75 2.6425 3.31625 2.625 5.25C2.6425 7.18375 4.2245 8.75 6.125 8.75M6.125 8.75H7M6.125 8.75C3.248 8.75 0.875 11.1002 0.875 14V15.75"
            stroke="white"
            strokeWidth="2"
          />
        </g>
        <defs>
          <clipPath id="clip0_175_315">
            <rect width="21" height="21" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: true,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: ["manage_users", "edit_users", "view_users"],
  },
  /**************ADMIN*********/
  {
    url: Path.admin,
    model_name: "admin",
    name: "Manage Admin",
    sidebar_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
      >
        <g clipPath="url(#clip0_175_315)">
          <path
            d="M10.5 11.375C11.4283 11.375 12.3185 11.0062 12.9749 10.3499C13.6313 9.6935 14 8.80326 14 7.875C14 6.94674 13.6313 6.0565 12.9749 5.40013C12.3185 4.74375 11.4283 4.375 10.5 4.375C9.57174 4.375 8.6815 4.74375 8.02513 5.40013C7.36875 6.0565 7 6.94674 7 7.875C7 8.80326 7.36875 9.6935 8.02513 10.3499C8.6815 11.0062 9.57174 11.375 10.5 11.375ZM10.5 11.375C9.10761 11.375 7.77226 11.9281 6.78769 12.9127C5.80312 13.8973 5.25 15.2326 5.25 16.625V19.25M10.5 11.375C11.8924 11.375 13.2277 11.9281 14.2123 12.9127C15.1969 13.8973 15.75 15.2326 15.75 16.625V19.25M11.375 4.375C11.7285 2.919 13.1381 1.75 14.875 1.75C16.7755 1.75 18.3575 3.31625 18.375 5.25C18.3575 7.18375 16.7755 8.75 14.875 8.75M14.875 8.75H14M14.875 8.75C17.752 8.75 20.125 11.1002 20.125 14V15.75M9.625 4.375C9.2715 2.919 7.86188 1.75 6.125 1.75C4.2245 1.75 2.6425 3.31625 2.625 5.25C2.6425 7.18375 4.2245 8.75 6.125 8.75M6.125 8.75H7M6.125 8.75C3.248 8.75 0.875 11.1002 0.875 14V15.75"
            stroke="white"
            strokeWidth="2"
          />
        </g>
        <defs>
          <clipPath id="clip0_175_315">
            <rect width="21" height="21" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: true,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: ["add_admin", "view_admin", "edit_admin", "delete_admin"],
  },
  //subadmins
  // {
  //   url: Path.subadmins,
  //   model_name: "Manage Sub Admins",
  //   name: "Manage Sub Admins",
  //   sidebar_icon: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="21"
  //       height="21"
  //       viewBox="0 0 21 21"
  //       fill="none"
  //     >
  //       <g clipPath="url(#clip0_175_315)">
  //         <path
  //           d="M10.5 11.375C11.4283 11.375 12.3185 11.0062 12.9749 10.3499C13.6313 9.6935 14 8.80326 14 7.875C14 6.94674 13.6313 6.0565 12.9749 5.40013C12.3185 4.74375 11.4283 4.375 10.5 4.375C9.57174 4.375 8.6815 4.74375 8.02513 5.40013C7.36875 6.0565 7 6.94674 7 7.875C7 8.80326 7.36875 9.6935 8.02513 10.3499C8.6815 11.0062 9.57174 11.375 10.5 11.375ZM10.5 11.375C9.10761 11.375 7.77226 11.9281 6.78769 12.9127C5.80312 13.8973 5.25 15.2326 5.25 16.625V19.25M10.5 11.375C11.8924 11.375 13.2277 11.9281 14.2123 12.9127C15.1969 13.8973 15.75 15.2326 15.75 16.625V19.25M11.375 4.375C11.7285 2.919 13.1381 1.75 14.875 1.75C16.7755 1.75 18.3575 3.31625 18.375 5.25C18.3575 7.18375 16.7755 8.75 14.875 8.75M14.875 8.75H14M14.875 8.75C17.752 8.75 20.125 11.1002 20.125 14V15.75M9.625 4.375C9.2715 2.919 7.86188 1.75 6.125 1.75C4.2245 1.75 2.6425 3.31625 2.625 5.25C2.6425 7.18375 4.2245 8.75 6.125 8.75M6.125 8.75H7M6.125 8.75C3.248 8.75 0.875 11.1002 0.875 14V15.75"
  //           stroke="white"
  //           strokeWidth="2"
  //         />
  //       </g>
  //       <defs>
  //         <clipPath id="clip0_175_315">
  //           <rect width="21" height="21" fill="white" />
  //         </clipPath>
  //       </defs>
  //     </svg>
  //   ),
  //   icon: "far fa fa-user",
  //   dashboard: false,
  //   is_modules: true,
  //   is_permission: true,
  //   is_sidebar: true,
  //   is_dropdown: false,
  //   is_open: false,
  //   count: 0,
  //   sub_modules: {},
  //   permission: ["subadmins"],
  // },
  {
    url: Path.coinList,
    model_name: "Coin List",
    name: "Coin List",
    sidebar_icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C10.8181 3 9.64778 3.23279 8.55585 3.68508C7.46392 4.13738 6.47177 4.80031 5.63604 5.63604C4.80031 6.47177 4.13738 7.46392 3.68508 8.55585C3.23279 9.64778 3 10.8181 3 12Z"
          stroke="white"
          strokewidth="2"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M14.8 9C14.6188 8.68576 14.3557 8.4267 14.0386 8.25055C13.7215 8.0744 13.3625 7.9878 13 8H11C10.4696 8 9.96086 8.21071 9.58579 8.58579C9.21071 8.96086 9 9.46957 9 10C9 10.5304 9.21071 11.0391 9.58579 11.4142C9.96086 11.7893 10.4696 12 11 12H13C13.5304 12 14.0391 12.2107 14.4142 12.5858C14.7893 12.9609 15 13.4696 15 14C15 14.5304 14.7893 15.0391 14.4142 15.4142C14.0391 15.7893 13.5304 16 13 16H11C10.6375 16.0122 10.2785 15.9256 9.96142 15.7494C9.64435 15.5733 9.38115 15.3142 9.2 15M12 7V17"
          stroke="white"
          strokewidth="2"
          strokelinecap="round"
          strokelinejoin="round"
        />
      </svg>
    ),
    icon: "far fa fa-coin",
    dashboard: false,
    is_modules: true,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: ["coin_list"],
  },
  {
    url: Path.gameHisory,
    model_name: "game-history",
    name: "Game History",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.45586 12.6494C10.0173 12.6494 10.4724 13.1012 10.4724 13.6585V14.9844H11.8198C12.207 14.9428 12.584 15.1244 12.7908 15.4521C12.9975 15.7797 12.9975 16.1957 12.7908 16.5234C12.584 16.851 12.207 17.0326 11.8198 16.991H10.4724V18.3287C10.466 18.8833 10.0146 19.3315 9.45586 19.3378C8.88726 19.3314 8.43932 18.8814 8.43935 18.3287V16.991H7.09189C6.70475 17.0326 6.32767 16.851 6.12096 16.5234C5.91426 16.1957 5.91426 15.7797 6.12096 15.4521C6.32767 15.1244 6.70475 14.9428 7.09189 14.9844H8.43935V13.6585L8.44863 13.5216C8.51594 13.029 8.94124 12.6494 9.45586 12.6494ZM18.9117 17.6012C19.1999 17.3146 19.6327 17.2269 20.011 17.3782C20.1325 17.4346 20.2442 17.5099 20.3419 17.6012C20.7305 17.992 20.7277 18.6211 20.3357 19.0086C19.9437 19.396 19.31 19.396 18.918 19.0086C18.526 18.6211 18.5232 17.992 18.9117 17.6012ZM16.9733 12.9075C17.2155 12.8084 17.4875 12.8084 17.7297 12.9075C17.8562 12.9614 17.9722 13.0369 18.0725 13.1305C18.26 13.3177 18.3661 13.5705 18.368 13.8345C18.3696 13.9669 18.3455 14.0984 18.2971 14.2217C18.2504 14.3478 18.1733 14.4606 18.0725 14.5503C17.6754 14.9258 17.0513 14.9258 16.6541 14.5503C16.4567 14.3662 16.3447 14.1093 16.3447 13.8404C16.3447 13.5715 16.4567 13.3145 16.6541 13.1305C16.743 13.0341 16.8519 12.958 16.9733 12.9075ZM26.6889 12.7015C26.51 8.59181 23.029 5.4458 18.8339 5.47516C18.32 5.48317 17.9089 5.90362 17.9156 6.41883C17.9222 6.93138 18.3413 7.35316 18.8579 7.33714C22.124 7.27174 24.6894 9.63425 24.8269 12.7803C24.8336 12.9031 24.8349 13.0272 24.8309 13.174V18.9655C24.8656 20.4885 24.3037 21.9313 23.2519 23.0298C22.2001 24.131 20.7826 24.7543 19.2583 24.7877C19.1342 24.7904 19.0087 24.7877 18.8299 24.7824C15.1259 24.8451 11.438 24.8451 7.81013 24.7837C4.64276 24.9199 2.00528 22.4786 1.86781 19.3419C1.86247 19.2165 1.86113 19.091 1.8638 18.9455V13.1527C1.79573 10.0107 4.29572 7.39988 7.4404 7.33314C7.5632 7.32913 7.68867 7.33314 7.85151 7.33714H14.1075C14.6214 7.33714 15.0392 6.9207 15.0392 6.40548V5.15749C15.0125 3.22477 13.4281 1.66444 11.5074 1.66444H11.4807H10.1593H10.1513C9.95508 1.66444 9.76955 1.58836 9.62807 1.44954C9.48391 1.31073 9.40383 1.12253 9.40249 0.922315C9.39715 0.411104 8.98071 0 8.47217 0H8.46149C7.94761 0.00533902 7.53517 0.427121 7.54051 0.941002C7.54852 1.63774 7.82615 2.29177 8.32401 2.77896C8.82321 3.27015 9.47991 3.49839 10.17 3.52776H11.4874H11.5007C12.4137 3.52776 13.1652 4.26721 13.1758 5.16817V5.47516L7.89155 5.4765C7.72471 5.46982 7.5592 5.46715 7.39636 5.46982C3.22925 5.56059 -0.0889448 9.02561 0.00181851 13.174V18.9268C-0.000851 19.091 0.000483755 19.2552 0.00715753 19.4207C0.190019 23.5851 3.71777 26.8486 7.83549 26.6444C9.6254 26.6764 11.4473 26.6911 13.2773 26.6911C15.1179 26.6911 16.9665 26.6764 18.8058 26.643C18.9727 26.6497 19.1382 26.6524 19.3024 26.6484C21.3205 26.6043 23.2012 25.7781 24.5973 24.3179C25.9935 22.859 26.7383 20.9436 26.6929 18.9455V13.1967C26.6969 13.0325 26.6956 12.867 26.6889 12.7015Z"
          fill="white"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: ["game_history", "view_game_history"],
  },

  {
    url: Path.jackpotHistory,
    model_name: "jackpot-history",
    name: "Jackpot History",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.45586 12.6494C10.0173 12.6494 10.4724 13.1012 10.4724 13.6585V14.9844H11.8198C12.207 14.9428 12.584 15.1244 12.7908 15.4521C12.9975 15.7797 12.9975 16.1957 12.7908 16.5234C12.584 16.851 12.207 17.0326 11.8198 16.991H10.4724V18.3287C10.466 18.8833 10.0146 19.3315 9.45586 19.3378C8.88726 19.3314 8.43932 18.8814 8.43935 18.3287V16.991H7.09189C6.70475 17.0326 6.32767 16.851 6.12096 16.5234C5.91426 16.1957 5.91426 15.7797 6.12096 15.4521C6.32767 15.1244 6.70475 14.9428 7.09189 14.9844H8.43935V13.6585L8.44863 13.5216C8.51594 13.029 8.94124 12.6494 9.45586 12.6494ZM18.9117 17.6012C19.1999 17.3146 19.6327 17.2269 20.011 17.3782C20.1325 17.4346 20.2442 17.5099 20.3419 17.6012C20.7305 17.992 20.7277 18.6211 20.3357 19.0086C19.9437 19.396 19.31 19.396 18.918 19.0086C18.526 18.6211 18.5232 17.992 18.9117 17.6012ZM16.9733 12.9075C17.2155 12.8084 17.4875 12.8084 17.7297 12.9075C17.8562 12.9614 17.9722 13.0369 18.0725 13.1305C18.26 13.3177 18.3661 13.5705 18.368 13.8345C18.3696 13.9669 18.3455 14.0984 18.2971 14.2217C18.2504 14.3478 18.1733 14.4606 18.0725 14.5503C17.6754 14.9258 17.0513 14.9258 16.6541 14.5503C16.4567 14.3662 16.3447 14.1093 16.3447 13.8404C16.3447 13.5715 16.4567 13.3145 16.6541 13.1305C16.743 13.0341 16.8519 12.958 16.9733 12.9075ZM26.6889 12.7015C26.51 8.59181 23.029 5.4458 18.8339 5.47516C18.32 5.48317 17.9089 5.90362 17.9156 6.41883C17.9222 6.93138 18.3413 7.35316 18.8579 7.33714C22.124 7.27174 24.6894 9.63425 24.8269 12.7803C24.8336 12.9031 24.8349 13.0272 24.8309 13.174V18.9655C24.8656 20.4885 24.3037 21.9313 23.2519 23.0298C22.2001 24.131 20.7826 24.7543 19.2583 24.7877C19.1342 24.7904 19.0087 24.7877 18.8299 24.7824C15.1259 24.8451 11.438 24.8451 7.81013 24.7837C4.64276 24.9199 2.00528 22.4786 1.86781 19.3419C1.86247 19.2165 1.86113 19.091 1.8638 18.9455V13.1527C1.79573 10.0107 4.29572 7.39988 7.4404 7.33314C7.5632 7.32913 7.68867 7.33314 7.85151 7.33714H14.1075C14.6214 7.33714 15.0392 6.9207 15.0392 6.40548V5.15749C15.0125 3.22477 13.4281 1.66444 11.5074 1.66444H11.4807H10.1593H10.1513C9.95508 1.66444 9.76955 1.58836 9.62807 1.44954C9.48391 1.31073 9.40383 1.12253 9.40249 0.922315C9.39715 0.411104 8.98071 0 8.47217 0H8.46149C7.94761 0.00533902 7.53517 0.427121 7.54051 0.941002C7.54852 1.63774 7.82615 2.29177 8.32401 2.77896C8.82321 3.27015 9.47991 3.49839 10.17 3.52776H11.4874H11.5007C12.4137 3.52776 13.1652 4.26721 13.1758 5.16817V5.47516L7.89155 5.4765C7.72471 5.46982 7.5592 5.46715 7.39636 5.46982C3.22925 5.56059 -0.0889448 9.02561 0.00181851 13.174V18.9268C-0.000851 19.091 0.000483755 19.2552 0.00715753 19.4207C0.190019 23.5851 3.71777 26.8486 7.83549 26.6444C9.6254 26.6764 11.4473 26.6911 13.2773 26.6911C15.1179 26.6911 16.9665 26.6764 18.8058 26.643C18.9727 26.6497 19.1382 26.6524 19.3024 26.6484C21.3205 26.6043 23.2012 25.7781 24.5973 24.3179C25.9935 22.859 26.7383 20.9436 26.6929 18.9455V13.1967C26.6969 13.0325 26.6956 12.867 26.6889 12.7015Z"
          fill="white"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: ["jackpot_history"],
  },
  {
    url: Path.weeklyRewardHistory,
    model_name: "weekly-reward-history",
    name: "Weekly Reward History",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
      >
        <path
          d="M15.0139 6.51813H14.9451C14.8442 6.51724 14.7459 6.48598 14.663 6.42842C14.5801 6.37086 14.5165 6.28967 14.4804 6.19544C14.4424 6.10444 14.4323 6.00419 14.4515 5.90746C14.4707 5.81073 14.5182 5.72189 14.588 5.65223L14.6369 5.60329C14.9319 5.30713 15.0976 4.90614 15.0976 4.48811C15.0976 4.07008 14.9319 3.66908 14.6369 3.37293L13.8242 2.56081C13.5283 2.26556 13.1274 2.09974 12.7093 2.09974C12.2913 2.09974 11.8903 2.26556 11.5944 2.56081L11.5455 2.60975C11.4734 2.67919 11.3826 2.72607 11.2842 2.74464C11.1858 2.76321 11.0842 2.75266 10.9917 2.71428C10.8993 2.67591 10.82 2.61137 10.7637 2.5286C10.7074 2.44583 10.6765 2.34843 10.6747 2.24833V2.17896C10.6743 1.76087 10.508 1.36002 10.2124 1.06439C9.91677 0.768753 9.51593 0.602478 9.09784 0.602051H7.94904C7.53095 0.602478 7.13011 0.768753 6.83447 1.06439C6.53884 1.36002 6.37256 1.76087 6.37214 2.17896V2.24833C6.36951 2.34771 6.33814 2.44419 6.28182 2.5261C6.22549 2.60801 6.14663 2.67184 6.05478 2.70986C5.96293 2.74787 5.86202 2.75845 5.76429 2.7403C5.66655 2.72215 5.57617 2.67606 5.50409 2.6076L5.45783 2.55866C5.16191 2.26341 4.76095 2.09759 4.34292 2.09759C3.92489 2.09759 3.52393 2.26341 3.22801 2.55866L2.41266 3.37078C2.11764 3.66693 1.95199 4.06793 1.95199 4.48596C1.95199 4.90399 2.11764 5.30498 2.41266 5.60114L2.46161 5.65008C2.53209 5.72219 2.57927 5.81383 2.59701 5.9131C2.61475 6.01236 2.60224 6.11467 2.5611 6.20673C2.5242 6.29843 2.46078 6.37704 2.37897 6.43251C2.29715 6.48798 2.20065 6.51779 2.1018 6.51813H2.03296C1.61487 6.51856 1.21403 6.68483 0.918391 6.98047C0.622757 7.2761 0.456482 7.67695 0.456055 8.09504V9.24383C0.456482 9.66192 0.622757 10.0628 0.918391 10.3584C1.21403 10.654 1.61487 10.8203 2.03296 10.8207H2.1018C2.20271 10.8216 2.301 10.8529 2.38389 10.9104C2.46677 10.968 2.5304 11.0492 2.56648 11.1434C2.60447 11.2344 2.61453 11.3347 2.59537 11.4314C2.57622 11.5281 2.52872 11.617 2.45892 11.6866L2.40997 11.7356C2.11495 12.0317 1.9493 12.4327 1.9493 12.8508C1.9493 13.2688 2.11495 13.6698 2.40997 13.9659L3.22209 14.7775C3.51797 15.0731 3.91907 15.2391 4.33727 15.2391C4.75548 15.2391 5.15658 15.0731 5.45245 14.7775L5.5014 14.7286C5.57355 14.6582 5.66518 14.611 5.76443 14.5933C5.86368 14.5755 5.96597 14.588 6.05805 14.6291C6.14974 14.6658 6.22838 14.7291 6.28386 14.8109C6.33934 14.8926 6.36914 14.9891 6.36945 15.0878V15.1572C6.3693 15.3647 6.41007 15.5702 6.4894 15.7619C6.56873 15.9536 6.68508 16.1278 6.83178 16.2745C6.97849 16.4212 7.15268 16.5375 7.34439 16.6169C7.5361 16.6962 7.74157 16.737 7.94904 16.7368H9.09784C9.51593 16.7364 9.91677 16.5701 10.2124 16.2745C10.508 15.9788 10.6743 15.578 10.6747 15.1599V15.0905C10.6774 14.9912 10.7087 14.8947 10.7651 14.8128C10.8214 14.7309 10.9002 14.667 10.9921 14.629C11.0839 14.591 11.1849 14.5804 11.2826 14.5986C11.3803 14.6167 11.4707 14.6628 11.5428 14.7313L11.5917 14.7802C11.8877 15.0755 12.2886 15.2413 12.7066 15.2413C13.1247 15.2413 13.5256 15.0755 13.8216 14.7802L14.6342 13.9686C14.9292 13.6725 15.0949 13.2715 15.0949 12.8534C15.0949 12.4354 14.9292 12.0344 14.6342 11.7383L14.5853 11.6893C14.5148 11.6172 14.4676 11.5256 14.4499 11.4263C14.4321 11.327 14.4446 11.2247 14.4858 11.1327C14.5226 11.0409 14.586 10.9622 14.6678 10.9066C14.7496 10.851 14.8462 10.8211 14.9451 10.8207H15.0139C15.432 10.8203 15.8328 10.654 16.1285 10.3584C16.4241 10.0628 16.5904 9.66192 16.5908 9.24383V8.09504C16.5904 7.67695 16.4241 7.2761 16.1285 6.98047C15.8328 6.68483 15.432 6.51856 15.0139 6.51813ZM15.5152 9.24383C15.515 9.37673 15.4622 9.50414 15.3682 9.59811C15.2742 9.69209 15.1468 9.74494 15.0139 9.74508H14.9451C14.633 9.74774 14.3286 9.84221 14.0698 10.0167C13.811 10.1912 13.6093 10.438 13.4898 10.7264C13.3704 11.0147 13.3384 11.3318 13.398 11.6382C13.4576 11.9446 13.606 12.2267 13.8248 12.4493L13.8732 12.4982C13.9671 12.5924 14.0198 12.7199 14.0198 12.8529C14.0198 12.9859 13.9671 13.1134 13.8732 13.2076L13.0605 14.0192C12.9665 14.1132 12.839 14.166 12.7061 14.166C12.5732 14.166 12.4457 14.1132 12.3517 14.0192L12.3033 13.9702C12.0806 13.7517 11.7985 13.6035 11.4922 13.5441C11.1859 13.4847 10.8689 13.5167 10.5807 13.6361C10.2924 13.7555 10.0457 13.9571 9.87114 14.2157C9.6966 14.4743 9.60199 14.7785 9.59909 15.0905V15.1599C9.59895 15.2928 9.54609 15.4202 9.45212 15.5142C9.35814 15.6082 9.23073 15.661 9.09784 15.6612H7.94904C7.81614 15.661 7.68873 15.6082 7.59476 15.5142C7.50078 15.4202 7.44793 15.2928 7.44779 15.1599V15.0905C7.44628 14.7779 7.35247 14.4727 7.17814 14.2132C7.00381 13.9537 6.75673 13.7514 6.46788 13.6318C6.17904 13.5122 5.86131 13.4806 5.55455 13.5409C5.24779 13.6012 4.96568 13.7507 4.7436 13.9708L4.69466 14.0197C4.60052 14.1135 4.47308 14.1661 4.34023 14.1661C4.20738 14.1661 4.07995 14.1135 3.9858 14.0197L3.17369 13.2081C3.07979 13.114 3.02706 12.9864 3.02706 12.8534C3.02706 12.7205 3.07979 12.5929 3.17369 12.4988L3.22263 12.4498C3.44163 12.2272 3.59022 11.945 3.64987 11.6385C3.70952 11.332 3.67758 11.0147 3.55803 10.7262C3.43849 10.4377 3.23663 10.1909 2.97766 10.0164C2.71868 9.84189 2.41406 9.74753 2.1018 9.74508H2.03296C1.90006 9.74494 1.77265 9.69209 1.67868 9.59811C1.5847 9.50414 1.53185 9.37673 1.53171 9.24383V8.09504C1.53185 7.96214 1.5847 7.83473 1.67868 7.74075C1.77265 7.64678 1.90006 7.59392 2.03296 7.59378H2.1018C2.41391 7.59113 2.71832 7.49666 2.9771 7.32216C3.23588 7.14767 3.43758 6.90086 3.55703 6.61251C3.67649 6.32416 3.70843 6.00702 3.64887 5.70064C3.58931 5.39426 3.44088 5.11219 3.22209 4.8896L3.17369 4.84065C3.07982 4.74658 3.02711 4.61912 3.02711 4.48623C3.02711 4.35334 3.07982 4.22587 3.17369 4.1318L3.9858 3.31915C4.07981 3.22515 4.2073 3.17234 4.34023 3.17234C4.47317 3.17234 4.60066 3.22515 4.69466 3.31915L4.74306 3.36809C4.96569 3.58677 5.24774 3.73512 5.55408 3.79466C5.86042 3.8542 6.1775 3.8223 6.46584 3.70293C6.75417 3.58356 7.00102 3.382 7.17562 3.12335C7.35023 2.8647 7.44488 2.56039 7.44779 2.24833V2.17896C7.44793 2.04606 7.50078 1.91865 7.59476 1.82467C7.68873 1.7307 7.81614 1.67784 7.94904 1.6777H9.09784C9.23073 1.67784 9.35814 1.7307 9.45212 1.82467C9.54609 1.91865 9.59895 2.04606 9.59909 2.17896V2.24833C9.60185 2.56039 9.69639 2.86474 9.87093 3.12344C10.0455 3.38214 10.2923 3.58375 10.5806 3.70314C10.8689 3.82253 11.186 3.85442 11.4924 3.79484C11.7987 3.73526 12.0807 3.58685 12.3033 3.36809L12.3522 3.31915C12.4462 3.22515 12.5737 3.17234 12.7066 3.17234C12.8396 3.17234 12.9671 3.22515 13.0611 3.31915L13.8732 4.1318C13.9671 4.22587 14.0198 4.35334 14.0198 4.48623C14.0198 4.61912 13.9671 4.74658 13.8732 4.84065L13.8242 4.8896C13.6054 5.11222 13.457 5.39434 13.3974 5.70077C13.3379 6.0072 13.3699 6.32438 13.4894 6.61275C13.6089 6.90112 13.8107 7.14793 14.0696 7.32238C14.3284 7.49684 14.6329 7.59123 14.9451 7.59378H15.0139C15.1468 7.59392 15.2742 7.64678 15.3682 7.74075C15.4622 7.83473 15.515 7.96214 15.5152 8.09504V9.24383Z"
          fill="white"
        ></path>
        <path
          d="M8.52333 4.90479C7.77872 4.90479 7.05084 5.12559 6.43173 5.53926C5.81261 5.95294 5.33007 6.54092 5.04512 7.22885C4.76018 7.91677 4.68562 8.67374 4.83089 9.40404C4.97615 10.1343 5.33471 10.8052 5.86122 11.3317C6.38774 11.8582 7.05856 12.2167 7.78885 12.362C8.51915 12.5073 9.27612 12.4327 9.96404 12.1478C10.652 11.8628 11.2399 11.3803 11.6536 10.7612C12.0673 10.142 12.2881 9.41417 12.2881 8.66956C12.287 7.67143 11.89 6.71451 11.1842 6.00872C10.4784 5.30293 9.52146 4.90592 8.52333 4.90479ZM8.52333 11.3587C7.99147 11.3587 7.47155 11.201 7.02933 10.9055C6.5871 10.61 6.24243 10.19 6.03889 9.69865C5.83536 9.20727 5.78211 8.66658 5.88587 8.14494C5.98963 7.6233 6.24574 7.14414 6.62182 6.76806C6.99791 6.39198 7.47706 6.13587 7.9987 6.03211C8.52034 5.92835 9.06104 5.9816 9.55241 6.18513C10.0438 6.38867 10.4638 6.73334 10.7593 7.17556C11.0547 7.61779 11.2125 8.1377 11.2125 8.66956C11.2116 9.3825 10.928 10.066 10.4239 10.5701C9.91976 11.0742 9.23626 11.3578 8.52333 11.3587Z"
          fill="white"
        ></path>
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: ["weekly_reward_history"],
  },
  {
    url: Path.gameLeaderboard,
    model_name: "game-leaderboard",
    name: "Leaderboard",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="33"
        height="33"
        viewBox="0 0 33 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.01764 29.897L9.81109 20.8255L9.92035 20.2729L9.50432 19.893L2.67416 13.6573L11.8553 12.5624L12.4152 12.4956L12.6478 11.982L16.464 3.55733L20.3424 11.9502L20.5789 12.462L21.1391 12.5246L30.3318 13.5518L23.5481 19.8402L23.135 20.2231L23.2484 20.7749L25.1096 29.8304L17.0394 25.3209L16.5472 25.0459L16.0572 25.3246L8.01764 29.897Z"
          stroke="white"
          strokewidth="2"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: ["leaderboard", "edit_leaderboard_points"],
  },
  {
    url: Path.claimHistory,
    model_name: "claim-history",
    name: "Claim History",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="27"
        height="28"
        viewBox="0 0 27 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.292 18.1958H10.3242"
          stroke="white"
          strokewidth="1.32732"
          stroke-miterlimit="10"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M12.9355 14.7568V21.2528"
          stroke="white"
          strokewidth="1.32732"
          stroke-miterlimit="10"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M14.8003 1.64214L14.7596 1.72889L10.8263 10.0696H6.96081C6.03851 10.0696 5.15691 10.2431 4.35669 10.5529L6.73023 5.37253L6.78448 5.24859L6.87943 5.0503C6.90655 4.97594 6.93368 4.90158 6.97437 4.83961C8.75113 1.08444 10.7585 0.229305 14.8003 1.64214Z"
          stroke="white"
          strokewidth="1.32732"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M21.2058 10.5538C20.6375 10.3781 20.0312 10.3027 19.425 10.3027H10.6975L14.3603 1.85302L14.3982 1.76514C14.5876 1.82791 14.7645 1.9158 14.9539 1.99113L17.7452 3.15877C19.2987 3.79909 20.3849 4.46452 21.0417 5.26806C21.168 5.41872 21.269 5.55683 21.3574 5.72005C21.4711 5.89582 21.5595 6.0716 21.61 6.25993C21.6605 6.37292 21.6984 6.48592 21.7237 6.58636C22.0647 7.64101 21.8626 8.9342 21.2058 10.5538Z"
          stroke="white"
          strokewidth="1.32732"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M25.6172 16.4945V19.0214C25.6172 19.2806 25.6045 19.5397 25.5919 19.7989C25.3522 24.3213 22.8917 26.6019 18.2232 26.6019H8.38137C8.07855 26.6019 7.77572 26.576 7.48551 26.5371C3.47308 26.265 1.32806 24.0621 1.06309 19.9414C1.02524 19.6434 1 19.3324 1 19.0214V16.4945C1 13.8899 2.53936 11.6482 4.73485 10.6763C5.49191 10.3523 6.29945 10.1709 7.15745 10.1709H19.4723C20.0906 10.1709 20.6962 10.2616 21.2514 10.4301C23.7624 11.2206 25.6172 13.6308 25.6172 16.4945Z"
          stroke="white"
          strokewidth="1.32732"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M6.9678 5.58545L4.75046 10.928C2.5458 11.8866 1 14.0978 1 16.6668V12.9219C1 9.29202 3.55944 6.26286 6.9678 5.58545Z"
          stroke="white"
          strokewidth="1.32732"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M25.6171 12.9358V16.6677C25.6171 13.8656 23.5711 11.4837 20.7683 10.7194C21.497 9.0636 21.7072 7.76441 21.3569 6.68175C21.3289 6.56712 21.2868 6.45248 21.2308 6.35059C23.8374 7.57335 25.6171 10.0826 25.6171 12.9358Z"
          stroke="white"
          strokewidth="1.32732"
          strokelinecap="round"
          strokelinejoin="round"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: ["claim_history"],
  },
  {
    url: Path.logs,
    model_name: "logs",
    name: "Logs",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27"
        height="28"
        viewBox="0 0 576 512"
      >
        <path
          fill="currentColor"
          d="M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5V78.6c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C93.5 32 46.3 45.3 18.1 56.1C6.8 60.5 0 71.7 0 83.8v370.3c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5m76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5V83.8c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-58.4 0-103.4 20-123 35.6c-3.3 2.6-5 6.8-5 11V456c0 11.4 11.7 19.3 22.4 15.5"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: ["logs"],
  },
  {
    url: Path.language,
    model_name: "language",
    name: "Manage Languages",
    sidebar_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        stroke="currentColor"
        strokewidth="2"
        strokelinecap="round"
        strokelinejoin="round"
        viewBox="0 0 24 24"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15 15 0 0 1 0 20" />
        <path d="M12 2a15 15 0 0 0 0 20" />
        <line x1="7" y1="7" x2="17" y2="17" />
        <line x1="7" y1="17" x2="17" y2="7" />

        <circle cx="12" cy="12" r="4" />
        <path d="M12 8v1" />
        <path d="M12 15v1" />
        <path d="M8 12h1" />
        <path d="M15 12h1" />
        <path d="M9.5 9.5l.7.7" />
        <path d="M14.5 14.5l.7.7" />
        <path d="M9.5 14.5l.7-.7" />
        <path d="M14.5 9.5l.7-.7" />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: ["language_settings", "edit_language_settings"],
  },
  {
    url: Path.tasksList,
    model_name: "tasks",
    name: "Tasks",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.8394 9.51855H20.3394"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M6.4231 9.51731L7.35167 10.4459L10.1374 7.66016"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M13.8394 18.1846H20.3394"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M6.4231 18.1848L7.35167 19.1134L10.1374 16.3276"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M9.66671 25.762H17.0953C23.2858 25.762 25.762 23.2858 25.762 17.0953V9.66671C25.762 3.4762 23.2858 1 17.0953 1H9.66671C3.4762 1 1 3.4762 1 9.66671V17.0953C1 23.2858 3.4762 25.762 9.66671 25.762Z"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: ["tasks", "add_task", "edit_task", "delete_task"],
  },
  {
    url: Path.roadmapsList,
    model_name: "roadmaps",
    name: "Roadmap",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.1749 9.44958V16.9473C26.1749 20.0714 25.2803 22.2867 23.8705 23.6988L16.105 15.6977L25.835 6.03809C26.0616 7.02529 26.1749 8.14996 26.1749 9.44958Z"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M26.1747 6.26972L6.44835 25.3493C2.6077 24.4978 1 21.9308 1 17.0437V9.63889C1 3.46825 3.55192 1 9.93173 1H17.5875C22.6403 1 25.2943 2.555 26.1747 6.26972Z"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M24.0774 23.3938C22.6661 24.7456 20.4805 25.3491 17.3582 25.3491H9.86466C8.56578 25.3491 7.44173 25.2405 6.45508 25.0232L16.1092 15.6934L24.0774 23.3938Z"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          opacity="0.4"
          d="M6.55736 8.34207C7.37573 4.70955 12.6711 4.70955 13.4895 8.34207C13.9588 10.4745 12.6591 12.2845 11.5157 13.4003C10.6853 14.2186 9.37353 14.2186 8.53109 13.4003C7.38778 12.2845 6.07597 10.4745 6.55736 8.34207Z"
          stroke="white"
          strokewidth="1.44445"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: ["roadmap", "add_roadmap", "edit_roadmap", "delete_roadmap"],
  },
  {
    url: Path.energyPackageList,
    model_name: "energy-packages",
    name: "Energy Packages",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.1749 9.44958V16.9473C26.1749 20.0714 25.2803 22.2867 23.8705 23.6988L16.105 15.6977L25.835 6.03809C26.0616 7.02529 26.1749 8.14996 26.1749 9.44958Z"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M26.1747 6.26972L6.44835 25.3493C2.6077 24.4978 1 21.9308 1 17.0437V9.63889C1 3.46825 3.55192 1 9.93173 1H17.5875C22.6403 1 25.2943 2.555 26.1747 6.26972Z"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M24.0774 23.3938C22.6661 24.7456 20.4805 25.3491 17.3582 25.3491H9.86466C8.56578 25.3491 7.44173 25.2405 6.45508 25.0232L16.1092 15.6934L24.0774 23.3938Z"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          opacity="0.4"
          d="M6.55736 8.34207C7.37573 4.70955 12.6711 4.70955 13.4895 8.34207C13.9588 10.4745 12.6591 12.2845 11.5157 13.4003C10.6853 14.2186 9.37353 14.2186 8.53109 13.4003C7.38778 12.2845 6.07597 10.4745 6.55736 8.34207Z"
          stroke="white"
          strokewidth="1.44445"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: [
      "energy_package",
      "view_energy_package",
      "add_energy_package",
      "edit_energy_package",
      "delete_energy_package",
    ],
  },
  {
    url: Path.energyPurchaseHistory,
    model_name: "energy-purchases",
    name: "Energy Purchase History",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.1749 9.44958V16.9473C26.1749 20.0714 25.2803 22.2867 23.8705 23.6988L16.105 15.6977L25.835 6.03809C26.0616 7.02529 26.1749 8.14996 26.1749 9.44958Z"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M26.1747 6.26972L6.44835 25.3493C2.6077 24.4978 1 21.9308 1 17.0437V9.63889C1 3.46825 3.55192 1 9.93173 1H17.5875C22.6403 1 25.2943 2.555 26.1747 6.26972Z"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M24.0774 23.3938C22.6661 24.7456 20.4805 25.3491 17.3582 25.3491H9.86466C8.56578 25.3491 7.44173 25.2405 6.45508 25.0232L16.1092 15.6934L24.0774 23.3938Z"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          opacity="0.4"
          d="M6.55736 8.34207C7.37573 4.70955 12.6711 4.70955 13.4895 8.34207C13.9588 10.4745 12.6591 12.2845 11.5157 13.4003C10.6853 14.2186 9.37353 14.2186 8.53109 13.4003C7.38778 12.2845 6.07597 10.4745 6.55736 8.34207Z"
          stroke="white"
          strokewidth="1.44445"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: ["energy_purchase_history", "view_energy_purchase_history"],
  },
  {
    url: Path.roundMultiplier,
    model_name: "round-multiplier",
    name: "Round Multiplier",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.1749 9.44958V16.9473C26.1749 20.0714 25.2803 22.2867 23.8705 23.6988L16.105 15.6977L25.835 6.03809C26.0616 7.02529 26.1749 8.14996 26.1749 9.44958Z"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M26.1747 6.26972L6.44835 25.3493C2.6077 24.4978 1 21.9308 1 17.0437V9.63889C1 3.46825 3.55192 1 9.93173 1H17.5875C22.6403 1 25.2943 2.555 26.1747 6.26972Z"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M24.0774 23.3938C22.6661 24.7456 20.4805 25.3491 17.3582 25.3491H9.86466C8.56578 25.3491 7.44173 25.2405 6.45508 25.0232L16.1092 15.6934L24.0774 23.3938Z"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          opacity="0.4"
          d="M6.55736 8.34207C7.37573 4.70955 12.6711 4.70955 13.4895 8.34207C13.9588 10.4745 12.6591 12.2845 11.5157 13.4003C10.6853 14.2186 9.37353 14.2186 8.53109 13.4003C7.38778 12.2845 6.07597 10.4745 6.55736 8.34207Z"
          stroke="white"
          strokewidth="1.44445"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: [
      "round_multiplier",
      "add_round_multiplier",
      "edit_round_multiplier",
      "delete_round_multiplier",
    ],
  },
  {
    url: Path.systemAnnouncement,
    model_name: "system-announcement",
    name: "System Announcement",
    sidebar_icon: (
      <svg
        width="27"
        height="27"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity="0.4"
        />
        <path
          d="M10.25 8.75H13.75C14.7165 8.75 15.5 9.5335 15.5 10.5V13.5C15.5 14.4665 14.7165 15.25 13.75 15.25H10.25V8.75Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.25 10.25H7.75C6.7835 10.25 6 11.0335 6 12C6 12.9665 6.7835 13.75 7.75 13.75H10.25V10.25Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.5 12H18"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: [
      "system_announcement",
      "add_system_announcement",
      "view_system_announcement",
    ],
  },
  {
    url: Path.exportRequest,
    model_name: "export-request",
    name: "Export Request",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.1749 9.44958V16.9473C26.1749 20.0714 25.2803 22.2867 23.8705 23.6988L16.105 15.6977L25.835 6.03809C26.0616 7.02529 26.1749 8.14996 26.1749 9.44958Z"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M26.1747 6.26972L6.44835 25.3493C2.6077 24.4978 1 21.9308 1 17.0437V9.63889C1 3.46825 3.55192 1 9.93173 1H17.5875C22.6403 1 25.2943 2.555 26.1747 6.26972Z"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M24.0774 23.3938C22.6661 24.7456 20.4805 25.3491 17.3582 25.3491H9.86466C8.56578 25.3491 7.44173 25.2405 6.45508 25.0232L16.1092 15.6934L24.0774 23.3938Z"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          opacity="0.4"
          d="M6.55736 8.34207C7.37573 4.70955 12.6711 4.70955 13.4895 8.34207C13.9588 10.4745 12.6591 12.2845 11.5157 13.4003C10.6853 14.2186 9.37353 14.2186 8.53109 13.4003C7.38778 12.2845 6.07597 10.4745 6.55736 8.34207Z"
          stroke="white"
          strokewidth="1.44445"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: ["export_request", "download_export_request"],
  },
  {
    url: Path.coinHistory,
    model_name: "coin-history",
    name: "Coin History",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.1749 9.44958V16.9473C26.1749 20.0714 25.2803 22.2867 23.8705 23.6988L16.105 15.6977L25.835 6.03809C26.0616 7.02529 26.1749 8.14996 26.1749 9.44958Z"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M26.1747 6.26972L6.44835 25.3493C2.6077 24.4978 1 21.9308 1 17.0437V9.63889C1 3.46825 3.55192 1 9.93173 1H17.5875C22.6403 1 25.2943 2.555 26.1747 6.26972Z"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M24.0774 23.3938C22.6661 24.7456 20.4805 25.3491 17.3582 25.3491H9.86466C8.56578 25.3491 7.44173 25.2405 6.45508 25.0232L16.1092 15.6934L24.0774 23.3938Z"
          stroke="white"
          strokewidth="1.44445"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          opacity="0.4"
          d="M6.55736 8.34207C7.37573 4.70955 12.6711 4.70955 13.4895 8.34207C13.9588 10.4745 12.6591 12.2845 11.5157 13.4003C10.6853 14.2186 9.37353 14.2186 8.53109 13.4003C7.38778 12.2845 6.07597 10.4745 6.55736 8.34207Z"
          stroke="white"
          strokewidth="1.44445"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: ["coin_history"],
  },
  {
    url: "#",
    model_name: "manageRole",
    name: "Manage Role",
    sidebar_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
      >
        <path
          d="M15.0139 6.51813H14.9451C14.8442 6.51724 14.7459 6.48598 14.663 6.42842C14.5801 6.37086 14.5165 6.28967 14.4804 6.19544C14.4424 6.10444 14.4323 6.00419 14.4515 5.90746C14.4707 5.81073 14.5182 5.72189 14.588 5.65223L14.6369 5.60329C14.9319 5.30713 15.0976 4.90614 15.0976 4.48811C15.0976 4.07008 14.9319 3.66908 14.6369 3.37293L13.8242 2.56081C13.5283 2.26556 13.1274 2.09974 12.7093 2.09974C12.2913 2.09974 11.8903 2.26556 11.5944 2.56081L11.5455 2.60975C11.4734 2.67919 11.3826 2.72607 11.2842 2.74464C11.1858 2.76321 11.0842 2.75266 10.9917 2.71428C10.8993 2.67591 10.82 2.61137 10.7637 2.5286C10.7074 2.44583 10.6765 2.34843 10.6747 2.24833V2.17896C10.6743 1.76087 10.508 1.36002 10.2124 1.06439C9.91677 0.768753 9.51593 0.602478 9.09784 0.602051H7.94904C7.53095 0.602478 7.13011 0.768753 6.83447 1.06439C6.53884 1.36002 6.37256 1.76087 6.37214 2.17896V2.24833C6.36951 2.34771 6.33814 2.44419 6.28182 2.5261C6.22549 2.60801 6.14663 2.67184 6.05478 2.70986C5.96293 2.74787 5.86202 2.75845 5.76429 2.7403C5.66655 2.72215 5.57617 2.67606 5.50409 2.6076L5.45783 2.55866C5.16191 2.26341 4.76095 2.09759 4.34292 2.09759C3.92489 2.09759 3.52393 2.26341 3.22801 2.55866L2.41266 3.37078C2.11764 3.66693 1.95199 4.06793 1.95199 4.48596C1.95199 4.90399 2.11764 5.30498 2.41266 5.60114L2.46161 5.65008C2.53209 5.72219 2.57927 5.81383 2.59701 5.9131C2.61475 6.01236 2.60224 6.11467 2.5611 6.20673C2.5242 6.29843 2.46078 6.37704 2.37897 6.43251C2.29715 6.48798 2.20065 6.51779 2.1018 6.51813H2.03296C1.61487 6.51856 1.21403 6.68483 0.918391 6.98047C0.622757 7.2761 0.456482 7.67695 0.456055 8.09504V9.24383C0.456482 9.66192 0.622757 10.0628 0.918391 10.3584C1.21403 10.654 1.61487 10.8203 2.03296 10.8207H2.1018C2.20271 10.8216 2.301 10.8529 2.38389 10.9104C2.46677 10.968 2.5304 11.0492 2.56648 11.1434C2.60447 11.2344 2.61453 11.3347 2.59537 11.4314C2.57622 11.5281 2.52872 11.617 2.45892 11.6866L2.40997 11.7356C2.11495 12.0317 1.9493 12.4327 1.9493 12.8508C1.9493 13.2688 2.11495 13.6698 2.40997 13.9659L3.22209 14.7775C3.51797 15.0731 3.91907 15.2391 4.33727 15.2391C4.75548 15.2391 5.15658 15.0731 5.45245 14.7775L5.5014 14.7286C5.57355 14.6582 5.66518 14.611 5.76443 14.5933C5.86368 14.5755 5.96597 14.588 6.05805 14.6291C6.14974 14.6658 6.22838 14.7291 6.28386 14.8109C6.33934 14.8926 6.36914 14.9891 6.36945 15.0878V15.1572C6.3693 15.3647 6.41007 15.5702 6.4894 15.7619C6.56873 15.9536 6.68508 16.1278 6.83178 16.2745C6.97849 16.4212 7.15268 16.5375 7.34439 16.6169C7.5361 16.6962 7.74157 16.737 7.94904 16.7368H9.09784C9.51593 16.7364 9.91677 16.5701 10.2124 16.2745C10.508 15.9788 10.6743 15.578 10.6747 15.1599V15.0905C10.6774 14.9912 10.7087 14.8947 10.7651 14.8128C10.8214 14.7309 10.9002 14.667 10.9921 14.629C11.0839 14.591 11.1849 14.5804 11.2826 14.5986C11.3803 14.6167 11.4707 14.6628 11.5428 14.7313L11.5917 14.7802C11.8877 15.0755 12.2886 15.2413 12.7066 15.2413C13.1247 15.2413 13.5256 15.0755 13.8216 14.7802L14.6342 13.9686C14.9292 13.6725 15.0949 13.2715 15.0949 12.8534C15.0949 12.4354 14.9292 12.0344 14.6342 11.7383L14.5853 11.6893C14.5148 11.6172 14.4676 11.5256 14.4499 11.4263C14.4321 11.327 14.4446 11.2247 14.4858 11.1327C14.5226 11.0409 14.586 10.9622 14.6678 10.9066C14.7496 10.851 14.8462 10.8211 14.9451 10.8207H15.0139C15.432 10.8203 15.8328 10.654 16.1285 10.3584C16.4241 10.0628 16.5904 9.66192 16.5908 9.24383V8.09504C16.5904 7.67695 16.4241 7.2761 16.1285 6.98047C15.8328 6.68483 15.432 6.51856 15.0139 6.51813ZM15.5152 9.24383C15.515 9.37673 15.4622 9.50414 15.3682 9.59811C15.2742 9.69209 15.1468 9.74494 15.0139 9.74508H14.9451C14.633 9.74774 14.3286 9.84221 14.0698 10.0167C13.811 10.1912 13.6093 10.438 13.4898 10.7264C13.3704 11.0147 13.3384 11.3318 13.398 11.6382C13.4576 11.9446 13.606 12.2267 13.8248 12.4493L13.8732 12.4982C13.9671 12.5924 14.0198 12.7199 14.0198 12.8529C14.0198 12.9859 13.9671 13.1134 13.8732 13.2076L13.0605 14.0192C12.9665 14.1132 12.839 14.166 12.7061 14.166C12.5732 14.166 12.4457 14.1132 12.3517 14.0192L12.3033 13.9702C12.0806 13.7517 11.7985 13.6035 11.4922 13.5441C11.1859 13.4847 10.8689 13.5167 10.5807 13.6361C10.2924 13.7555 10.0457 13.9571 9.87114 14.2157C9.6966 14.4743 9.60199 14.7785 9.59909 15.0905V15.1599C9.59895 15.2928 9.54609 15.4202 9.45212 15.5142C9.35814 15.6082 9.23073 15.661 9.09784 15.6612H7.94904C7.81614 15.661 7.68873 15.6082 7.59476 15.5142C7.50078 15.4202 7.44793 15.2928 7.44779 15.1599V15.0905C7.44628 14.7779 7.35247 14.4727 7.17814 14.2132C7.00381 13.9537 6.75673 13.7514 6.46788 13.6318C6.17904 13.5122 5.86131 13.4806 5.55455 13.5409C5.24779 13.6012 4.96568 13.7507 4.7436 13.9708L4.69466 14.0197C4.60052 14.1135 4.47308 14.1661 4.34023 14.1661C4.20738 14.1661 4.07995 14.1135 3.9858 14.0197L3.17369 13.2081C3.07979 13.114 3.02706 12.9864 3.02706 12.8534C3.02706 12.7205 3.07979 12.5929 3.17369 12.4988L3.22263 12.4498C3.44163 12.2272 3.59022 11.945 3.64987 11.6385C3.70952 11.332 3.67758 11.0147 3.55803 10.7262C3.43849 10.4377 3.23663 10.1909 2.97766 10.0164C2.71868 9.84189 2.41406 9.74753 2.1018 9.74508H2.03296C1.90006 9.74494 1.77265 9.69209 1.67868 9.59811C1.5847 9.50414 1.53185 9.37673 1.53171 9.24383V8.09504C1.53185 7.96214 1.5847 7.83473 1.67868 7.74075C1.77265 7.64678 1.90006 7.59392 2.03296 7.59378H2.1018C2.41391 7.59113 2.71832 7.49666 2.9771 7.32216C3.23588 7.14767 3.43758 6.90086 3.55703 6.61251C3.67649 6.32416 3.70843 6.00702 3.64887 5.70064C3.58931 5.39426 3.44088 5.11219 3.22209 4.8896L3.17369 4.84065C3.07982 4.74658 3.02711 4.61912 3.02711 4.48623C3.02711 4.35334 3.07982 4.22587 3.17369 4.1318L3.9858 3.31915C4.07981 3.22515 4.2073 3.17234 4.34023 3.17234C4.47317 3.17234 4.60066 3.22515 4.69466 3.31915L4.74306 3.36809C4.96569 3.58677 5.24774 3.73512 5.55408 3.79466C5.86042 3.8542 6.1775 3.8223 6.46584 3.70293C6.75417 3.58356 7.00102 3.382 7.17562 3.12335C7.35023 2.8647 7.44488 2.56039 7.44779 2.24833V2.17896C7.44793 2.04606 7.50078 1.91865 7.59476 1.82467C7.68873 1.7307 7.81614 1.67784 7.94904 1.6777H9.09784C9.23073 1.67784 9.35814 1.7307 9.45212 1.82467C9.54609 1.91865 9.59895 2.04606 9.59909 2.17896V2.24833C9.60185 2.56039 9.69639 2.86474 9.87093 3.12344C10.0455 3.38214 10.2923 3.58375 10.5806 3.70314C10.8689 3.82253 11.186 3.85442 11.4924 3.79484C11.7987 3.73526 12.0807 3.58685 12.3033 3.36809L12.3522 3.31915C12.4462 3.22515 12.5737 3.17234 12.7066 3.17234C12.8396 3.17234 12.9671 3.22515 13.0611 3.31915L13.8732 4.1318C13.9671 4.22587 14.0198 4.35334 14.0198 4.48623C14.0198 4.61912 13.9671 4.74658 13.8732 4.84065L13.8242 4.8896C13.6054 5.11222 13.457 5.39434 13.3974 5.70077C13.3379 6.0072 13.3699 6.32438 13.4894 6.61275C13.6089 6.90112 13.8107 7.14793 14.0696 7.32238C14.3284 7.49684 14.6329 7.59123 14.9451 7.59378H15.0139C15.1468 7.59392 15.2742 7.64678 15.3682 7.74075C15.4622 7.83473 15.515 7.96214 15.5152 8.09504V9.24383Z"
          fill="white"
        ></path>
        <path
          d="M8.52333 4.90479C7.77872 4.90479 7.05084 5.12559 6.43173 5.53926C5.81261 5.95294 5.33007 6.54092 5.04512 7.22885C4.76018 7.91677 4.68562 8.67374 4.83089 9.40404C4.97615 10.1343 5.33471 10.8052 5.86122 11.3317C6.38774 11.8582 7.05856 12.2167 7.78885 12.362C8.51915 12.5073 9.27612 12.4327 9.96404 12.1478C10.652 11.8628 11.2399 11.3803 11.6536 10.7612C12.0673 10.142 12.2881 9.41417 12.2881 8.66956C12.287 7.67143 11.89 6.71451 11.1842 6.00872C10.4784 5.30293 9.52146 4.90592 8.52333 4.90479ZM8.52333 11.3587C7.99147 11.3587 7.47155 11.201 7.02933 10.9055C6.5871 10.61 6.24243 10.19 6.03889 9.69865C5.83536 9.20727 5.78211 8.66658 5.88587 8.14494C5.98963 7.6233 6.24574 7.14414 6.62182 6.76806C6.99791 6.39198 7.47706 6.13587 7.9987 6.03211C8.52034 5.92835 9.06104 5.9816 9.55241 6.18513C10.0438 6.38867 10.4638 6.73334 10.7593 7.17556C11.0547 7.61779 11.2125 8.1377 11.2125 8.66956C11.2116 9.3825 10.928 10.066 10.4239 10.5701C9.91976 11.0742 9.23626 11.3578 8.52333 11.3587Z"
          fill="white"
        ></path>
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: true,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: [
      "add_role",
      "edit_role",
      "view_role",
      "delete_role",
      "add_permission",
      "edit_permission",
      "view_permission",
      "delete_permission",
      "add_permission_meta",
      "edit_permission_meta",
      "view_permission_meta",
      "delete_permission_meta"
    ],
    dropdown_module: [
      {
        url: Path.role,
        model_name: "role",
        name: "Role",
        sidebar_icon: "fas fa-fire",
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: false,
        is_dropdown: false,
        is_open: false,
        count: 0,
        sub_modules: {},
        permission: ["add_role", "edit_role", "view_role", "delete_role"],
      },
      {
        url: Path.permission,
        model_name: "permission",
        name: "Permission",
        sidebar_icon: "fas fa-fire",
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: false,
        is_dropdown: false,
        is_open: false,
        count: 0,
        sub_modules: {},
        permission: ["add_permission", "edit_permission", "view_permission", "delete_permission"],
      },
      {
        url: Path.permissionMeta,
        model_name: "permissionMeta",
        name: "Permission Meta",
        sidebar_icon: "fas fa-fire",
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: false,
        is_dropdown: false,
        is_open: false,
        count: 0,
        sub_modules: {},
        permission: ["add_permission_meta", "edit_permission_meta", "view_permission_meta", "delete_permission_meta"],
      }
    ],
  },
  {
    url: "#",
    model_name: "configuration",
    name: "Configuration",
    sidebar_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
      >
        <path
          d="M15.0139 6.51813H14.9451C14.8442 6.51724 14.7459 6.48598 14.663 6.42842C14.5801 6.37086 14.5165 6.28967 14.4804 6.19544C14.4424 6.10444 14.4323 6.00419 14.4515 5.90746C14.4707 5.81073 14.5182 5.72189 14.588 5.65223L14.6369 5.60329C14.9319 5.30713 15.0976 4.90614 15.0976 4.48811C15.0976 4.07008 14.9319 3.66908 14.6369 3.37293L13.8242 2.56081C13.5283 2.26556 13.1274 2.09974 12.7093 2.09974C12.2913 2.09974 11.8903 2.26556 11.5944 2.56081L11.5455 2.60975C11.4734 2.67919 11.3826 2.72607 11.2842 2.74464C11.1858 2.76321 11.0842 2.75266 10.9917 2.71428C10.8993 2.67591 10.82 2.61137 10.7637 2.5286C10.7074 2.44583 10.6765 2.34843 10.6747 2.24833V2.17896C10.6743 1.76087 10.508 1.36002 10.2124 1.06439C9.91677 0.768753 9.51593 0.602478 9.09784 0.602051H7.94904C7.53095 0.602478 7.13011 0.768753 6.83447 1.06439C6.53884 1.36002 6.37256 1.76087 6.37214 2.17896V2.24833C6.36951 2.34771 6.33814 2.44419 6.28182 2.5261C6.22549 2.60801 6.14663 2.67184 6.05478 2.70986C5.96293 2.74787 5.86202 2.75845 5.76429 2.7403C5.66655 2.72215 5.57617 2.67606 5.50409 2.6076L5.45783 2.55866C5.16191 2.26341 4.76095 2.09759 4.34292 2.09759C3.92489 2.09759 3.52393 2.26341 3.22801 2.55866L2.41266 3.37078C2.11764 3.66693 1.95199 4.06793 1.95199 4.48596C1.95199 4.90399 2.11764 5.30498 2.41266 5.60114L2.46161 5.65008C2.53209 5.72219 2.57927 5.81383 2.59701 5.9131C2.61475 6.01236 2.60224 6.11467 2.5611 6.20673C2.5242 6.29843 2.46078 6.37704 2.37897 6.43251C2.29715 6.48798 2.20065 6.51779 2.1018 6.51813H2.03296C1.61487 6.51856 1.21403 6.68483 0.918391 6.98047C0.622757 7.2761 0.456482 7.67695 0.456055 8.09504V9.24383C0.456482 9.66192 0.622757 10.0628 0.918391 10.3584C1.21403 10.654 1.61487 10.8203 2.03296 10.8207H2.1018C2.20271 10.8216 2.301 10.8529 2.38389 10.9104C2.46677 10.968 2.5304 11.0492 2.56648 11.1434C2.60447 11.2344 2.61453 11.3347 2.59537 11.4314C2.57622 11.5281 2.52872 11.617 2.45892 11.6866L2.40997 11.7356C2.11495 12.0317 1.9493 12.4327 1.9493 12.8508C1.9493 13.2688 2.11495 13.6698 2.40997 13.9659L3.22209 14.7775C3.51797 15.0731 3.91907 15.2391 4.33727 15.2391C4.75548 15.2391 5.15658 15.0731 5.45245 14.7775L5.5014 14.7286C5.57355 14.6582 5.66518 14.611 5.76443 14.5933C5.86368 14.5755 5.96597 14.588 6.05805 14.6291C6.14974 14.6658 6.22838 14.7291 6.28386 14.8109C6.33934 14.8926 6.36914 14.9891 6.36945 15.0878V15.1572C6.3693 15.3647 6.41007 15.5702 6.4894 15.7619C6.56873 15.9536 6.68508 16.1278 6.83178 16.2745C6.97849 16.4212 7.15268 16.5375 7.34439 16.6169C7.5361 16.6962 7.74157 16.737 7.94904 16.7368H9.09784C9.51593 16.7364 9.91677 16.5701 10.2124 16.2745C10.508 15.9788 10.6743 15.578 10.6747 15.1599V15.0905C10.6774 14.9912 10.7087 14.8947 10.7651 14.8128C10.8214 14.7309 10.9002 14.667 10.9921 14.629C11.0839 14.591 11.1849 14.5804 11.2826 14.5986C11.3803 14.6167 11.4707 14.6628 11.5428 14.7313L11.5917 14.7802C11.8877 15.0755 12.2886 15.2413 12.7066 15.2413C13.1247 15.2413 13.5256 15.0755 13.8216 14.7802L14.6342 13.9686C14.9292 13.6725 15.0949 13.2715 15.0949 12.8534C15.0949 12.4354 14.9292 12.0344 14.6342 11.7383L14.5853 11.6893C14.5148 11.6172 14.4676 11.5256 14.4499 11.4263C14.4321 11.327 14.4446 11.2247 14.4858 11.1327C14.5226 11.0409 14.586 10.9622 14.6678 10.9066C14.7496 10.851 14.8462 10.8211 14.9451 10.8207H15.0139C15.432 10.8203 15.8328 10.654 16.1285 10.3584C16.4241 10.0628 16.5904 9.66192 16.5908 9.24383V8.09504C16.5904 7.67695 16.4241 7.2761 16.1285 6.98047C15.8328 6.68483 15.432 6.51856 15.0139 6.51813ZM15.5152 9.24383C15.515 9.37673 15.4622 9.50414 15.3682 9.59811C15.2742 9.69209 15.1468 9.74494 15.0139 9.74508H14.9451C14.633 9.74774 14.3286 9.84221 14.0698 10.0167C13.811 10.1912 13.6093 10.438 13.4898 10.7264C13.3704 11.0147 13.3384 11.3318 13.398 11.6382C13.4576 11.9446 13.606 12.2267 13.8248 12.4493L13.8732 12.4982C13.9671 12.5924 14.0198 12.7199 14.0198 12.8529C14.0198 12.9859 13.9671 13.1134 13.8732 13.2076L13.0605 14.0192C12.9665 14.1132 12.839 14.166 12.7061 14.166C12.5732 14.166 12.4457 14.1132 12.3517 14.0192L12.3033 13.9702C12.0806 13.7517 11.7985 13.6035 11.4922 13.5441C11.1859 13.4847 10.8689 13.5167 10.5807 13.6361C10.2924 13.7555 10.0457 13.9571 9.87114 14.2157C9.6966 14.4743 9.60199 14.7785 9.59909 15.0905V15.1599C9.59895 15.2928 9.54609 15.4202 9.45212 15.5142C9.35814 15.6082 9.23073 15.661 9.09784 15.6612H7.94904C7.81614 15.661 7.68873 15.6082 7.59476 15.5142C7.50078 15.4202 7.44793 15.2928 7.44779 15.1599V15.0905C7.44628 14.7779 7.35247 14.4727 7.17814 14.2132C7.00381 13.9537 6.75673 13.7514 6.46788 13.6318C6.17904 13.5122 5.86131 13.4806 5.55455 13.5409C5.24779 13.6012 4.96568 13.7507 4.7436 13.9708L4.69466 14.0197C4.60052 14.1135 4.47308 14.1661 4.34023 14.1661C4.20738 14.1661 4.07995 14.1135 3.9858 14.0197L3.17369 13.2081C3.07979 13.114 3.02706 12.9864 3.02706 12.8534C3.02706 12.7205 3.07979 12.5929 3.17369 12.4988L3.22263 12.4498C3.44163 12.2272 3.59022 11.945 3.64987 11.6385C3.70952 11.332 3.67758 11.0147 3.55803 10.7262C3.43849 10.4377 3.23663 10.1909 2.97766 10.0164C2.71868 9.84189 2.41406 9.74753 2.1018 9.74508H2.03296C1.90006 9.74494 1.77265 9.69209 1.67868 9.59811C1.5847 9.50414 1.53185 9.37673 1.53171 9.24383V8.09504C1.53185 7.96214 1.5847 7.83473 1.67868 7.74075C1.77265 7.64678 1.90006 7.59392 2.03296 7.59378H2.1018C2.41391 7.59113 2.71832 7.49666 2.9771 7.32216C3.23588 7.14767 3.43758 6.90086 3.55703 6.61251C3.67649 6.32416 3.70843 6.00702 3.64887 5.70064C3.58931 5.39426 3.44088 5.11219 3.22209 4.8896L3.17369 4.84065C3.07982 4.74658 3.02711 4.61912 3.02711 4.48623C3.02711 4.35334 3.07982 4.22587 3.17369 4.1318L3.9858 3.31915C4.07981 3.22515 4.2073 3.17234 4.34023 3.17234C4.47317 3.17234 4.60066 3.22515 4.69466 3.31915L4.74306 3.36809C4.96569 3.58677 5.24774 3.73512 5.55408 3.79466C5.86042 3.8542 6.1775 3.8223 6.46584 3.70293C6.75417 3.58356 7.00102 3.382 7.17562 3.12335C7.35023 2.8647 7.44488 2.56039 7.44779 2.24833V2.17896C7.44793 2.04606 7.50078 1.91865 7.59476 1.82467C7.68873 1.7307 7.81614 1.67784 7.94904 1.6777H9.09784C9.23073 1.67784 9.35814 1.7307 9.45212 1.82467C9.54609 1.91865 9.59895 2.04606 9.59909 2.17896V2.24833C9.60185 2.56039 9.69639 2.86474 9.87093 3.12344C10.0455 3.38214 10.2923 3.58375 10.5806 3.70314C10.8689 3.82253 11.186 3.85442 11.4924 3.79484C11.7987 3.73526 12.0807 3.58685 12.3033 3.36809L12.3522 3.31915C12.4462 3.22515 12.5737 3.17234 12.7066 3.17234C12.8396 3.17234 12.9671 3.22515 13.0611 3.31915L13.8732 4.1318C13.9671 4.22587 14.0198 4.35334 14.0198 4.48623C14.0198 4.61912 13.9671 4.74658 13.8732 4.84065L13.8242 4.8896C13.6054 5.11222 13.457 5.39434 13.3974 5.70077C13.3379 6.0072 13.3699 6.32438 13.4894 6.61275C13.6089 6.90112 13.8107 7.14793 14.0696 7.32238C14.3284 7.49684 14.6329 7.59123 14.9451 7.59378H15.0139C15.1468 7.59392 15.2742 7.64678 15.3682 7.74075C15.4622 7.83473 15.515 7.96214 15.5152 8.09504V9.24383Z"
          fill="white"
        ></path>
        <path
          d="M8.52333 4.90479C7.77872 4.90479 7.05084 5.12559 6.43173 5.53926C5.81261 5.95294 5.33007 6.54092 5.04512 7.22885C4.76018 7.91677 4.68562 8.67374 4.83089 9.40404C4.97615 10.1343 5.33471 10.8052 5.86122 11.3317C6.38774 11.8582 7.05856 12.2167 7.78885 12.362C8.51915 12.5073 9.27612 12.4327 9.96404 12.1478C10.652 11.8628 11.2399 11.3803 11.6536 10.7612C12.0673 10.142 12.2881 9.41417 12.2881 8.66956C12.287 7.67143 11.89 6.71451 11.1842 6.00872C10.4784 5.30293 9.52146 4.90592 8.52333 4.90479ZM8.52333 11.3587C7.99147 11.3587 7.47155 11.201 7.02933 10.9055C6.5871 10.61 6.24243 10.19 6.03889 9.69865C5.83536 9.20727 5.78211 8.66658 5.88587 8.14494C5.98963 7.6233 6.24574 7.14414 6.62182 6.76806C6.99791 6.39198 7.47706 6.13587 7.9987 6.03211C8.52034 5.92835 9.06104 5.9816 9.55241 6.18513C10.0438 6.38867 10.4638 6.73334 10.7593 7.17556C11.0547 7.61779 11.2125 8.1377 11.2125 8.66956C11.2116 9.3825 10.928 10.066 10.4239 10.5701C9.91976 11.0742 9.23626 11.3578 8.52333 11.3587Z"
          fill="white"
        ></path>
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: true,
    is_open: false,
    count: 0,
    sub_modules: {},
    // permission: ["game_settings", "energy_settings", "leaderboard_settings", "maintenance_settings", "edit_game_settings", "edit_energy_settings", "edit_leaderboard_settings", "edit_maintenance_settings", "welcome_bonus_settings", "edit_welcome_bonus_settings", "crypto_exchange_settings", "edit_crypto_exchange_settings", "conversion_settings", "edit_conversion_settings", , "promotion_settings", "edit_promotion_settings"],
    permission: [
      "game_settings",
      "energy_settings",
      "leaderboard_settings",
      "maintenance_settings",
      "edit_game_settings",
      "edit_energy_settings",
      "edit_leaderboard_settings",
      "edit_maintenance_settings",
      "welcome_bonus_settings",
      "edit_welcome_bonus_settings",
      "crypto_exchange_settings",
      "edit_crypto_exchange_settings",
      "conversion_settings",
      "edit_conversion_settings",
      "promotion_settings",
      "edit_promotion_settings",
      "crypto_deposit_settings",
      "edit_crypto_deposit_settings",
      "payment_setting",
      "edit_payment_setting",
      "buy_energy_setting",
      "edit_buy_energy_setting",
      "energy_purchase_history",
      "reward_system_settings",
      "edit_reward_system_settings",
      "jackpot_settings",
      "edit_jackpot_settings",
    ],
    dropdown_module: [
      {
        url: Path.game_setting,
        model_name: "game_setting",
        name: "Game Setting",
        sidebar_icon: "fas fa-fire",
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: false,
        is_dropdown: false,
        is_open: false,
        count: 0,
        sub_modules: {},
        permission: ["game_settings", "edit_game_settings"],
      },
      {
        url: Path.energy_setting,
        model_name: "energy_setting",
        name: "Energy Setting",
        sidebar_icon: "fas fa-fire",
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: false,
        is_dropdown: false,
        is_open: false,
        count: 0,
        sub_modules: {},
        permission: ["energy_settings", "edit_energy_settings"],
      },
      {
        url: Path.leaderboard_setting,
        model_name: "leaderboard_setting",
        name: "Leaderboard Setting",
        sidebar_icon: "fas fa-fire",
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: false,
        is_dropdown: false,
        is_open: false,
        count: 0,
        sub_modules: {},
        permission: ["leaderboard_settings", "edit_leaderboard_settings"],
      },
      ,
      {
        url: Path.maintenance_setting,
        model_name: "maintenance_setting",
        name: "Maintenance Setting",
        sidebar_icon: "fas fa-fire",
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: false,
        is_dropdown: false,
        is_open: false,
        count: 0,
        sub_modules: {},
        permission: ["maintenance_settings", "edit_maintenance_settings"],
      },
      {
        url: Path.welcome_bonus_setting,
        model_name: "welcome_bonus_settings",
        name: "Verification Bonus Setting",
        sidebar_icon: "fas fa-fire",
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: false,
        is_dropdown: false,
        is_open: false,
        count: 0,
        sub_modules: {},
        permission: ["welcome_bonus_settings", "edit_welcome_bonus_settings"],
      },
      {
        url: Path.crypto_exchange_setting,
        model_name: "crypto_exchange_settings",
        name: "Crypto Exchange Setting",
        sidebar_icon: "fas fa-fire",
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: false,
        is_dropdown: false,
        is_open: false,
        count: 0,
        sub_modules: {},
        permission: [
          "crypto_exchange_settings",
          "edit_crypto_exchange_settings",
        ],
      },
      {
        url: Path.crypto_conversion_setting,
        model_name: "crypto_conversion_setting",
        name: "Crypto Conversion Setting",
        sidebar_icon: "fas fa-fire",
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: false,
        is_dropdown: false,
        is_open: false,
        count: 0,
        sub_modules: {},
        permission: ["conversion_settings", "edit_conversion_settings"],
      },
      {
        url: Path.crypto_deposit_setting,
        model_name: "crypto_deposit_setting",
        name: "Crypto Deposit Settings",
        sidebar_icon: "fas fa-fire",
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: false,
        is_dropdown: false,
        is_open: false,
        count: 0,
        sub_modules: {},
        permission: ["crypto_deposit_settings", "edit_crypto_deposit_settings"],
      },
      {
        url: Path.promotion_4gb_setting,
        model_name: "promotion_4gb_setting",
        name: "Promotion Setting",
        sidebar_icon: "fas fa-fire",
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: false,
        is_dropdown: false,
        is_open: false,
        count: 0,
        sub_modules: {},
        permission: ["promotion_settings", "edit_promotion_settings"],
      },
      {
        url: Path.payment_setting,
        model_name: "payment_setting",
        name: "Payment Setting",
        sidebar_icon: "fas fa-fire",
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: false,
        is_dropdown: false,
        is_open: false,
        count: 0,
        sub_modules: {},
        permission: ["payment_setting", "edit_payment_setting"],
      },
      {
        url: Path.reward_system_settings,
        model_name: "reward_system_settings",
        name: "Reward System Setting",
        sidebar_icon: "fas fa-fire",
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: false,
        is_dropdown: false,
        is_open: false,
        count: 0,
        sub_modules: {},
        permission: ["reward_system_settings", "edit_reward_system_settings"],
      },
      {
        url: Path.jackpot_settings,
        model_name: "jackpot_settings",
        name: "Jackpot Setting",
        sidebar_icon: "fas fa-fire",
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: false,
        is_dropdown: false,
        is_open: false,
        count: 0,
        sub_modules: {},
        permission: ["jackpot_settings", "edit_jackpot_settings"],
      },
      {
        url: Path.buy_energy_settings,
        model_name: "buyenergy",
        name: "Buy Energy Setting",
        sidebar_icon: "fas fa-fire",
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: false,
        is_dropdown: false,
        is_open: false,
        count: 0,
        sub_modules: {},
        permission: ["buy_energy_setting", "edit_buy_energy_setting"],
      },
    ],
  },
  {
    url: "#",
    model_name: "histricaldata",
    name: "Histrical Data",
    sidebar_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
      >
        <path
          d="M15.0139 6.51813H14.9451C14.8442 6.51724 14.7459 6.48598 14.663 6.42842C14.5801 6.37086 14.5165 6.28967 14.4804 6.19544C14.4424 6.10444 14.4323 6.00419 14.4515 5.90746C14.4707 5.81073 14.5182 5.72189 14.588 5.65223L14.6369 5.60329C14.9319 5.30713 15.0976 4.90614 15.0976 4.48811C15.0976 4.07008 14.9319 3.66908 14.6369 3.37293L13.8242 2.56081C13.5283 2.26556 13.1274 2.09974 12.7093 2.09974C12.2913 2.09974 11.8903 2.26556 11.5944 2.56081L11.5455 2.60975C11.4734 2.67919 11.3826 2.72607 11.2842 2.74464C11.1858 2.76321 11.0842 2.75266 10.9917 2.71428C10.8993 2.67591 10.82 2.61137 10.7637 2.5286C10.7074 2.44583 10.6765 2.34843 10.6747 2.24833V2.17896C10.6743 1.76087 10.508 1.36002 10.2124 1.06439C9.91677 0.768753 9.51593 0.602478 9.09784 0.602051H7.94904C7.53095 0.602478 7.13011 0.768753 6.83447 1.06439C6.53884 1.36002 6.37256 1.76087 6.37214 2.17896V2.24833C6.36951 2.34771 6.33814 2.44419 6.28182 2.5261C6.22549 2.60801 6.14663 2.67184 6.05478 2.70986C5.96293 2.74787 5.86202 2.75845 5.76429 2.7403C5.66655 2.72215 5.57617 2.67606 5.50409 2.6076L5.45783 2.55866C5.16191 2.26341 4.76095 2.09759 4.34292 2.09759C3.92489 2.09759 3.52393 2.26341 3.22801 2.55866L2.41266 3.37078C2.11764 3.66693 1.95199 4.06793 1.95199 4.48596C1.95199 4.90399 2.11764 5.30498 2.41266 5.60114L2.46161 5.65008C2.53209 5.72219 2.57927 5.81383 2.59701 5.9131C2.61475 6.01236 2.60224 6.11467 2.5611 6.20673C2.5242 6.29843 2.46078 6.37704 2.37897 6.43251C2.29715 6.48798 2.20065 6.51779 2.1018 6.51813H2.03296C1.61487 6.51856 1.21403 6.68483 0.918391 6.98047C0.622757 7.2761 0.456482 7.67695 0.456055 8.09504V9.24383C0.456482 9.66192 0.622757 10.0628 0.918391 10.3584C1.21403 10.654 1.61487 10.8203 2.03296 10.8207H2.1018C2.20271 10.8216 2.301 10.8529 2.38389 10.9104C2.46677 10.968 2.5304 11.0492 2.56648 11.1434C2.60447 11.2344 2.61453 11.3347 2.59537 11.4314C2.57622 11.5281 2.52872 11.617 2.45892 11.6866L2.40997 11.7356C2.11495 12.0317 1.9493 12.4327 1.9493 12.8508C1.9493 13.2688 2.11495 13.6698 2.40997 13.9659L3.22209 14.7775C3.51797 15.0731 3.91907 15.2391 4.33727 15.2391C4.75548 15.2391 5.15658 15.0731 5.45245 14.7775L5.5014 14.7286C5.57355 14.6582 5.66518 14.611 5.76443 14.5933C5.86368 14.5755 5.96597 14.588 6.05805 14.6291C6.14974 14.6658 6.22838 14.7291 6.28386 14.8109C6.33934 14.8926 6.36914 14.9891 6.36945 15.0878V15.1572C6.3693 15.3647 6.41007 15.5702 6.4894 15.7619C6.56873 15.9536 6.68508 16.1278 6.83178 16.2745C6.97849 16.4212 7.15268 16.5375 7.34439 16.6169C7.5361 16.6962 7.74157 16.737 7.94904 16.7368H9.09784C9.51593 16.7364 9.91677 16.5701 10.2124 16.2745C10.508 15.9788 10.6743 15.578 10.6747 15.1599V15.0905C10.6774 14.9912 10.7087 14.8947 10.7651 14.8128C10.8214 14.7309 10.9002 14.667 10.9921 14.629C11.0839 14.591 11.1849 14.5804 11.2826 14.5986C11.3803 14.6167 11.4707 14.6628 11.5428 14.7313L11.5917 14.7802C11.8877 15.0755 12.2886 15.2413 12.7066 15.2413C13.1247 15.2413 13.5256 15.0755 13.8216 14.7802L14.6342 13.9686C14.9292 13.6725 15.0949 13.2715 15.0949 12.8534C15.0949 12.4354 14.9292 12.0344 14.6342 11.7383L14.5853 11.6893C14.5148 11.6172 14.4676 11.5256 14.4499 11.4263C14.4321 11.327 14.4446 11.2247 14.4858 11.1327C14.5226 11.0409 14.586 10.9622 14.6678 10.9066C14.7496 10.851 14.8462 10.8211 14.9451 10.8207H15.0139C15.432 10.8203 15.8328 10.654 16.1285 10.3584C16.4241 10.0628 16.5904 9.66192 16.5908 9.24383V8.09504C16.5904 7.67695 16.4241 7.2761 16.1285 6.98047C15.8328 6.68483 15.432 6.51856 15.0139 6.51813ZM15.5152 9.24383C15.515 9.37673 15.4622 9.50414 15.3682 9.59811C15.2742 9.69209 15.1468 9.74494 15.0139 9.74508H14.9451C14.633 9.74774 14.3286 9.84221 14.0698 10.0167C13.811 10.1912 13.6093 10.438 13.4898 10.7264C13.3704 11.0147 13.3384 11.3318 13.398 11.6382C13.4576 11.9446 13.606 12.2267 13.8248 12.4493L13.8732 12.4982C13.9671 12.5924 14.0198 12.7199 14.0198 12.8529C14.0198 12.9859 13.9671 13.1134 13.8732 13.2076L13.0605 14.0192C12.9665 14.1132 12.839 14.166 12.7061 14.166C12.5732 14.166 12.4457 14.1132 12.3517 14.0192L12.3033 13.9702C12.0806 13.7517 11.7985 13.6035 11.4922 13.5441C11.1859 13.4847 10.8689 13.5167 10.5807 13.6361C10.2924 13.7555 10.0457 13.9571 9.87114 14.2157C9.6966 14.4743 9.60199 14.7785 9.59909 15.0905V15.1599C9.59895 15.2928 9.54609 15.4202 9.45212 15.5142C9.35814 15.6082 9.23073 15.661 9.09784 15.6612H7.94904C7.81614 15.661 7.68873 15.6082 7.59476 15.5142C7.50078 15.4202 7.44793 15.2928 7.44779 15.1599V15.0905C7.44628 14.7779 7.35247 14.4727 7.17814 14.2132C7.00381 13.9537 6.75673 13.7514 6.46788 13.6318C6.17904 13.5122 5.86131 13.4806 5.55455 13.5409C5.24779 13.6012 4.96568 13.7507 4.7436 13.9708L4.69466 14.0197C4.60052 14.1135 4.47308 14.1661 4.34023 14.1661C4.20738 14.1661 4.07995 14.1135 3.9858 14.0197L3.17369 13.2081C3.07979 13.114 3.02706 12.9864 3.02706 12.8534C3.02706 12.7205 3.07979 12.5929 3.17369 12.4988L3.22263 12.4498C3.44163 12.2272 3.59022 11.945 3.64987 11.6385C3.70952 11.332 3.67758 11.0147 3.55803 10.7262C3.43849 10.4377 3.23663 10.1909 2.97766 10.0164C2.71868 9.84189 2.41406 9.74753 2.1018 9.74508H2.03296C1.90006 9.74494 1.77265 9.69209 1.67868 9.59811C1.5847 9.50414 1.53185 9.37673 1.53171 9.24383V8.09504C1.53185 7.96214 1.5847 7.83473 1.67868 7.74075C1.77265 7.64678 1.90006 7.59392 2.03296 7.59378H2.1018C2.41391 7.59113 2.71832 7.49666 2.9771 7.32216C3.23588 7.14767 3.43758 6.90086 3.55703 6.61251C3.67649 6.32416 3.70843 6.00702 3.64887 5.70064C3.58931 5.39426 3.44088 5.11219 3.22209 4.8896L3.17369 4.84065C3.07982 4.74658 3.02711 4.61912 3.02711 4.48623C3.02711 4.35334 3.07982 4.22587 3.17369 4.1318L3.9858 3.31915C4.07981 3.22515 4.2073 3.17234 4.34023 3.17234C4.47317 3.17234 4.60066 3.22515 4.69466 3.31915L4.74306 3.36809C4.96569 3.58677 5.24774 3.73512 5.55408 3.79466C5.86042 3.8542 6.1775 3.8223 6.46584 3.70293C6.75417 3.58356 7.00102 3.382 7.17562 3.12335C7.35023 2.8647 7.44488 2.56039 7.44779 2.24833V2.17896C7.44793 2.04606 7.50078 1.91865 7.59476 1.82467C7.68873 1.7307 7.81614 1.67784 7.94904 1.6777H9.09784C9.23073 1.67784 9.35814 1.7307 9.45212 1.82467C9.54609 1.91865 9.59895 2.04606 9.59909 2.17896V2.24833C9.60185 2.56039 9.69639 2.86474 9.87093 3.12344C10.0455 3.38214 10.2923 3.58375 10.5806 3.70314C10.8689 3.82253 11.186 3.85442 11.4924 3.79484C11.7987 3.73526 12.0807 3.58685 12.3033 3.36809L12.3522 3.31915C12.4462 3.22515 12.5737 3.17234 12.7066 3.17234C12.8396 3.17234 12.9671 3.22515 13.0611 3.31915L13.8732 4.1318C13.9671 4.22587 14.0198 4.35334 14.0198 4.48623C14.0198 4.61912 13.9671 4.74658 13.8732 4.84065L13.8242 4.8896C13.6054 5.11222 13.457 5.39434 13.3974 5.70077C13.3379 6.0072 13.3699 6.32438 13.4894 6.61275C13.6089 6.90112 13.8107 7.14793 14.0696 7.32238C14.3284 7.49684 14.6329 7.59123 14.9451 7.59378H15.0139C15.1468 7.59392 15.2742 7.64678 15.3682 7.74075C15.4622 7.83473 15.515 7.96214 15.5152 8.09504V9.24383Z"
          fill="white"
        ></path>
        <path
          d="M8.52333 4.90479C7.77872 4.90479 7.05084 5.12559 6.43173 5.53926C5.81261 5.95294 5.33007 6.54092 5.04512 7.22885C4.76018 7.91677 4.68562 8.67374 4.83089 9.40404C4.97615 10.1343 5.33471 10.8052 5.86122 11.3317C6.38774 11.8582 7.05856 12.2167 7.78885 12.362C8.51915 12.5073 9.27612 12.4327 9.96404 12.1478C10.652 11.8628 11.2399 11.3803 11.6536 10.7612C12.0673 10.142 12.2881 9.41417 12.2881 8.66956C12.287 7.67143 11.89 6.71451 11.1842 6.00872C10.4784 5.30293 9.52146 4.90592 8.52333 4.90479ZM8.52333 11.3587C7.99147 11.3587 7.47155 11.201 7.02933 10.9055C6.5871 10.61 6.24243 10.19 6.03889 9.69865C5.83536 9.20727 5.78211 8.66658 5.88587 8.14494C5.98963 7.6233 6.24574 7.14414 6.62182 6.76806C6.99791 6.39198 7.47706 6.13587 7.9987 6.03211C8.52034 5.92835 9.06104 5.9816 9.55241 6.18513C10.0438 6.38867 10.4638 6.73334 10.7593 7.17556C11.0547 7.61779 11.2125 8.1377 11.2125 8.66956C11.2116 9.3825 10.928 10.066 10.4239 10.5701C9.91976 11.0742 9.23626 11.3578 8.52333 11.3587Z"
          fill="white"
        ></path>
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: true,
    is_open: false,
    count: 0,
    sub_modules: {},
    permission: [
      "move_data_mySql",
      "remove_data_mongoDb",
      "delete_data_from_mongoDb",
      "historical_data_setting",
      "edit_historical_data_setting",
    ],
    dropdown_module: [
      {
        url: Path.mongotoMysql,
        model_name: "move_data_mySql",
        name: "MySql Backup Data",
        sidebar_icon: "fas fa-fire",
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: false,
        is_dropdown: false,
        is_open: false,
        count: 0,
        sub_modules: {},
        permission: ["move_data_mySql"],
      },
      {
        url: Path.removefromMongo,
        model_name: "remove_data_mongoDb",
        name: "Delete Data From Monogo",
        sidebar_icon: "fas fa-fire",
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: false,
        is_dropdown: false,
        is_open: false,
        count: 0,
        sub_modules: {},
        permission: ["remove_data_mongoDb", "delete_data_from_mongoDb"],
      },
      {
        url: Path.historicalDataSetting,
        model_name: "historical_data_setting",
        name: "Historical Data Setting",
        sidebar_icon: "fas fa-fire",
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: false,
        is_dropdown: false,
        is_open: false,
        count: 0,
        sub_modules: {},
        permission: ["historical_data_setting", "edit_historical_data_setting"],
      },
    ],
  },
];
